import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

export default {
  priorities: [
    { value: 'LOW', icon: ArrowDownwardIcon },
    { value: 'MEDIUM', icon: ArrowDownwardIcon },
    { value: 'HIGH', icon: ArrowUpwardIcon },
    { value: 'URGENT', icon: ArrowUpwardIcon },
  ],
  statuses: [
    { value: 'OPEN', filter: 'unique' },
    { value: 'ALL_ACTIVE', filter: 'all' },
    { value: 'APPROVED', filter: 'unique' },
    { value: 'ALL_INACTIVE', filter: 'all' },
    { value: 'CANCELLED', filter: 'unique' },
    { value: 'INPROGRESS', filter: 'unique' },
    { value: 'COMPLETED', filter: 'unique' },
    { value: 'PENDING_APPROVAL', filter: 'unique' },
  ],
};
